'use client';

import { useDialog } from '../../hooks/useDialog';
import { AlertCircle } from 'lucide-react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export const Dialog = () => {
  const {
    isOpen,
    title,
    description,
    confirmText,
    cancelText,
    variant,
    onConfirm,
    onCancel,
  } = useDialog();

  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
    return;
  }, [isOpen]);

  if (!isOpen) return null;

  const content = (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center pointer-events-auto">
      <div className="absolute inset-0 bg-black/60" onClick={onCancel} />
      <div className="relative bg-white rounded-xl p-6 max-w-md w-full mx-4 z-10">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          {variant === 'danger' && (
            <AlertCircle className="w-6 h-6 text-red-600" />
          )}
          {variant === 'warning' && (
            <AlertCircle className="w-6 h-6 text-[#B98900]" />
          )}
          {variant === 'info' && (
            <AlertCircle className="w-6 h-6 text-blue-600" />
          )}
          <h3 className="text-lg font-medium text-[#0D373D]">{title}</h3>
        </div>

        {/* Description */}
        <p className="text-[#7A7D81] mb-6 whitespace-pre-line">{description}</p>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3">
          {cancelText && (
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-[#7A7D81] hover:text-[#0D373D]"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium text-white rounded-lg ${
              variant === 'danger'
                ? 'bg-red-600 hover:bg-red-700'
                : variant === 'warning'
                  ? 'bg-[#B98900] hover:bg-[#A67E00]'
                  : 'bg-[#0D373D] hover:bg-[#0D373D]/90'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};
